import { useContext } from "react"
import AuthContext from "store/context/PublicContext"
import { AppContext } from "store/context/AppContext"
import useCancelToken from "hooks/useCancelToken"
import OMNIX_MODULE from "constants/OMNIX_MODULE"
import {
  post_module_entity_action_middleware,
  post_formdata_module_entity_action_middleware,
} from "services/middleware_services"
import Swal from "sweetalert2"

interface IPostLoadParams {
  body: any
  type: string
}

const useMassiveLoadResources = () => {
  const { newCancelToken, isCancel } = useCancelToken()
  const {
    user: { token },
  } = useContext(AuthContext)
  const { loading_app, set_loading_app } = useContext(AppContext)

  const post_upload_file_massive_load_action = async ({ body, type }: IPostLoadParams) => {
    try {
      return await post_formdata_module_entity_action_middleware(
        OMNIX_MODULE.OLM,
        `massive_load?type=${type}`,
        body,
        token,
        newCancelToken(),
      )
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  const post_list_massive_load_action = async ({ body }: { body: any }) => {
    try {
      return await post_module_entity_action_middleware(
        OMNIX_MODULE.OLM,
        `massive_load/all`,
        body,
        token,
        newCancelToken(),
      )
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  return {
    post_upload_file_massive_load_action,
    post_list_massive_load_action,
    loading_app,
    set_loading_app,
  }
}

export default useMassiveLoadResources
